export const TICKET_CATEGORIES = {
  GENERAL: 'general',
  TECHNICAL: 'technical',
  ACCOUNT: 'account',
  BILLING: 'billing',
  FEATURE_REQUEST: 'feature_request',
  OTHER: 'other',
};

export const ISSUE_GENERAL_LOOM_FIELD_ID = 360006824778;
export const ISSUE_TECHNICAL_FIELD_ID = 360006856877;
export const ISSUE_LOOM_ACCOUNT_FIELD_ID = 360006826518;
export const ISSUE_BILLING_FIELD_ID = 360006826678;
export const ISSUE_FEATURE_REQUEST_FIELD_ID = 360006826698;
export const ISSUE_OTHER_FIELD_ID = 360006826758;
export const CUSTOMER_PLAN_FIELD_ID = 360003144817;
export const LOOM_PLATFORM_FIELD_ID = 360006165297;
export const PERMISSION_TO_IMPERSONATE_FIELD_ID = 360006825798;
export const VIDEO_LINK_FIELD_ID = 360002891498;

export const GENERAL_FORM_ID = 360000137237;
export const TECHNICAL_FORM_ID = 360000149198;
export const ACCOUNT_FORM_ID = 360000137257;
export const BILLING_FORM_ID = 360000149218;
export const FEATURE_REQUEST_FORM_ID = 360000149238;
